/* angular:styles/component:css;3441b5696d6abf2bd959d18bcb31dde8239a6ad8185bfa659af60bc764c238a8;/app/frontend_mobile/src/app/components/buttons/annulla-prenotazione/annulla-prenotazione.component.ts */
/*# sourceMappingURL=annulla-prenotazione.component.css.map */
